import { render, staticRenderFns } from "./FAQAdmin.vue?vue&type=template&id=5f6eb2d1&"
import script from "./FAQAdmin.vue?vue&type=script&lang=js&"
export * from "./FAQAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports